import { useState } from "react";
import { format, parseISO } from "date-fns";
import { tr } from "date-fns/locale";
import { Calendar as CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export default function DatePicker({ value, onChange, placeholder = "Tarih seçin", testId }) {
  const [open, setOpen] = useState(false);
  let selected;
  try {
    selected = value ? parseISO(value) : undefined;
  } catch {
    selected = undefined;
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className="flex items-center gap-2 w-full px-3 py-2 border border-[#E7DECC] bg-white rounded-sm text-left text-sm hover:border-[#B8933F] focus:outline-none focus:border-[#B8933F] transition-colors duration-150"
        >
          <CalendarIcon className="w-4 h-4 text-[#8C8377] shrink-0" />
          {selected ? (
            <span className="tabular-nums">{format(selected, "dd MMMM yyyy", { locale: tr })}</span>
          ) : (
            <span className="text-[#8C8377]">{placeholder}</span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 rounded-sm z-[200]" align="start">
        <Calendar
          mode="single"
          locale={tr}
          selected={selected}
          onSelect={(d) => {
            onChange(d ? format(d, "yyyy-MM-dd") : "");
            setOpen(false);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
